import axios from 'axios';
import config from '../config';

export const generateMoleculeExplanation = async (moleculeName) => {
  console.log('🧪 Requesting explanation for:', moleculeName);

  try {
    const response = await axios.post(
      `${config.backendUrl}/api/explain-molecule`,
      {
        moleculeName: moleculeName,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const { explanation, source } = response.data;
    console.log(`✅ Received explanation from ${source}`);

    return explanation;
  } catch (error) {
    console.error('⚠️ Backend API error:', error);
    return 'Unable to generate explanation at this time. Please ensure the backend server is running.';
  }
};
